import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { QueryService } from '../comun/services/query.service';
import Swal from 'sweetalert2';
import { Cuidado } from '../comun/models/salud-cuidado.model';
import { SaludService } from '../comun/services/salud.service';
// Para cargar el perfil del usuario conectado
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UsuarioPerfil } from '../comun/models/misdatos.model';
import { Mascota } from '../comun/models/mascota.model';
import { MisdatosService } from '../comun/services/misdatos.service';
import { PerfilService } from '../comun/services/perfil.service';
import { MascotasService } from '../comun/services/mascotas.service';

type CuidadoPeriodico = Cuidado & { mc_periodicidad?: string; mc_intervalo?: number; mc_estado?: string };

@Component({
  selector: 'app-salud',
  templateUrl: './salud.component.html',
  styleUrls: ['./salud.component.css']
})
export class SaludComponent implements OnInit, OnDestroy {
  @Input() userid: number = 0;
  private misdatosSub!: Subscription;
  misdatos: any = {};
  private perfilSub!: Subscription;
  perfil: any = {};
  private mascotasSub!: Subscription;
  mascotas: any[] = [];
  mascotaSeleccionada: any = null;
  tipoCuidados: any[] = [];
  cuidados: CuidadoPeriodico[] = [];
  nuevocuidado: CuidadoPeriodico = { mc_id: 0, mc_us_id: 0, mc_ma_id: 0, mc_tipo: '', mc_fecha: '', mc_hora: '', mc_notas: '', mc_realizado: '', mc_caducado: '', mc_periodicidad: 'ninguna', mc_intervalo: 1, va_nombre: '', ma_nombre: '' };
  busy: number = 0;
  guardando = false;
  avatarFallback = '';
  periodicidades = [
    {valor:'ninguna',texto:'Una sola vez'}, {valor:'diaria',texto:'Cada día'},
    {valor:'semanal',texto:'Cada semana'}, {valor:'quincenal',texto:'Cada 15 días'},
    {valor:'mensual',texto:'Cada mes'}, {valor:'trimestral',texto:'Cada 3 meses'},
    {valor:'semestral',texto:'Cada 6 meses'}, {valor:'anual',texto:'Cada año'},
    {valor:'personalizada',texto:'Cada N días'}
  ];
  periodicidadNombre(c: any): string {
    if (c.mc_periodicidad === 'personalizada') return 'Cada ' + (c.mc_intervalo || 1) + ' días';
    return this.periodicidades.find(p => p.valor === c.mc_periodicidad)?.texto || '';
  }
  avisoHoy(c: any): boolean { return c.mc_estado === 'hoy' && c.mc_realizado !== 'X'; }
  avisoAtrasado(c: any): boolean { return c.mc_estado === 'atrasado' && c.mc_realizado !== 'X'; }


  getTipoVisual(c: any): string {
    const t = String(c?.va_nombre || '').toLowerCase();
    if (t.includes('vacun')) return 'vacuna';
    if (t.includes('medic')) return 'medicacion';
    if (t.includes('revis') || t.includes('veter') || t.includes('consulta') || t.includes('control')) return 'revision';
    if (t.includes('hig') || t.includes('aseo') || t.includes('bañ') || t.includes('bano') || t.includes('limpieza')) return 'higiene';
    if (t.includes('aliment') || t.includes('comida') || t.includes('pienso') || t.includes('dieta')) return 'alimentacion';
    if (t.includes('paseo') || t.includes('ejercicio') || t.includes('actividad')) return 'actividad';
    return 'otro';
  }

  getTipoIcono(c: any): string {
    switch (this.getTipoVisual(c)) {
      case 'vacuna': return 'fa-syringe';
      case 'medicacion': return 'fa-pills';
      case 'revision': return 'fa-stethoscope';
      case 'higiene': return 'fa-shower';
      case 'alimentacion': return 'fa-bowl-food';
      case 'actividad': return 'fa-person-walking';
      default: return 'fa-heart-pulse';
    }
  }


  get cuidadosFiltrados(): CuidadoPeriodico[] { return this.obtenerCuidadosPorMascota(); }
  get pendientesCount(): number { return this.cuidadosFiltrados.filter(c => c.mc_realizado !== 'X').length; }
  trackByMascota(_index: number, m: any): number { return m.ma_id; }
  trackByCuidado(_index: number, c: Cuidado): number { return c.mc_id; }

  constructor(private query: QueryService, 
              private misdatosService: MisdatosService, 
              private perfilService: PerfilService,
              private mascotasService: MascotasService,
              private saludService: SaludService) {
  }

  ngOnInit() {
    this.getTipoCuidados();
    this.getMisDatos();
  }

  getMisDatos() {
    ++this.busy;
    // 1. Escuchamos el observable
    this.misdatosSub = this.misdatosService.misdatos$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((misdatos): misdatos is UsuarioPerfil => misdatos !== null)
      )
      .subscribe((misdatos: UsuarioPerfil) => {
        // Ya tenemos datos
        this.misdatos = misdatos;
        --this.busy;
        
        this.getPerfil();
      });
    /*++this.busy;
    this.query.query('misdatos', 'GET', { ID: 0 }).subscribe((resultado:any) => {
      this.misdatos = resultado;
      --this.busy;
      this.getPerfil();
    });*/
  }
  ngOnDestroy() {
    // Es buena práctica desuscribirse para evitar fugas de memoria
    this.misdatosSub?.unsubscribe();
    this.perfilSub?.unsubscribe();
    this.mascotasSub?.unsubscribe();
  }

  getPerfil() {
    ++this.busy;
    // 1. Escuchamos el observable
    this.perfilSub?.unsubscribe();
    this.perfilSub = this.perfilService.perfil$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((perfil): perfil is UsuarioPerfil => perfil !== null)
      )
      .subscribe((perfil: UsuarioPerfil) => {
        // Ya tenemos datos
        this.perfil = perfil;
        if (this.perfil.ID == this.misdatos.ID && this.perfil.rol_social) {
          this.getNextcuidado();
          this.getMascotas();
        }
        --this.busy;
      });
    /*if (this.userid == this.misdatos.ID) {
      this.perfil = this.misdatos;
      this.getMascotas();
    } else {
      ++this.busy;
      this.query.query('misdatos', 'GET', { ID: this.userid }).subscribe((resultado:any) => {
        this.perfil = resultado;
        --this.busy;
        this.getMascotas();
      });
    }*/
  }

  /*getMascotas(mascota: any = null) {
    if (!this.perfil.rol_social || this.perfil.ID != this.misdatos.ID)
      return;
    ++this.busy;
    this.query.query('mascotas', 'GET', { ID: this.userid }).subscribe((resultado:any) => {
      this.mascotas = resultado.registros;
      --this.busy;
      this.getCuidados();
    });
  }*/

  getMascotas() {
    // Escuchamos el observable mascotas$ (que ahora emite Mascota[])
    this.mascotasSub?.unsubscribe();
    this.mascotasSub = this.mascotasService.mascotas$ // O mascotas$, usa el nombre de tu variable del servicio
      .pipe(
        // FILTRO: Solo continúa si el array no está vacío. 
        // Si prefieres que se ejecute aunque esté vacío, puedes borrar todo el bloque .pipe(...)
        filter((mascotas): mascotas is Mascota[] => Array.isArray(mascotas))
      )
      .subscribe((mascotas: Mascota[]) => {
        // Ya tenemos el array con datos
        this.mascotas = mascotas; 
        
        this.getCuidados();

      });
  }

  seleccionarMascota(mascota: any) {
    this.mascotaSeleccionada = mascota;
  }

  getMascota(id: number) {
    return this.mascotas.find(m => Number(m.ma_id) === Number(id));
  }

  getTipoCuidados() {
    ++this.busy;
    this.query.query('valores', 'GET', { grupo: 'CUIDADOS'}).subscribe({next: (resultado:any) => {
      this.tipoCuidados = resultado?.registros || []; --this.busy;
    }, error: () => { --this.busy; }});
  }

  getCuidados() {
    ++this.busy;
    this.query.query('cuidados', 'GET', null).subscribe({next: (resultado:any) => {
      this.cuidados = resultado?.registros || []; --this.busy;
    }, error: () => { --this.busy; Swal.fire('Error', 'No se han podido cargar los cuidados.', 'error'); }});
  }

  obtenerCuidadosPorMascota(): CuidadoPeriodico[] {
    if (!this.mascotaSeleccionada) return this.cuidados; // Si no hay mascota seleccionada, devuelve todo (opcional)
    
    return this.cuidados.filter(cuidado => Number(cuidado.mc_ma_id) === Number(this.mascotaSeleccionada.ma_id));
  }

  guardarCuidado() {
    if (this.validaFormulario() || this.guardando) return;
    this.guardando = true;
    const nuevo = !this.nuevocuidado.mc_id;
    if (nuevo) this.nuevocuidado.mc_us_id = this.perfil.ID;
    this.query.query('cuidados', nuevo ? 'NUEVO' : 'ACTUALIZAR', this.nuevocuidado).subscribe({
      next: (resultado: any) => {
        this.guardando = false;
        if (resultado?.resultado === 'ERROR') { Swal.fire('Error', resultado?.mensaje || 'No se pudo guardar.', 'error'); return; }
        this.getCuidados(); this.getNextcuidado();
        // Bootstrap 5 modal, sin dependencia de tipos globales.
        const modal = document.getElementById('anadirModal');
        const cerrar = modal?.querySelector<HTMLButtonElement>('.btn-close');
        cerrar?.click();
      },
      error: () => { this.guardando = false; Swal.fire('Error', 'No se pudo guardar el cuidado.', 'error'); }
    });
  }

  // Comparamos fechas de calendario en Canarias, sin bloquear por la hora del cuidado.
  // Las fechas de MySQL llegan normalmente como YYYY-MM-DD (o YYYY-MM-DD HH:mm:ss).
  esCuidadoFuturo(cuidado: any): boolean {
    if (!cuidado || cuidado.mc_realizado === 'X') return false;
    const fecha = String(cuidado.mc_fecha || '').slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(fecha)) return true;
    const partes = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Atlantic/Canary', year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(new Date());
    const valor = (tipo: string) => partes.find(p => p.type === tipo)?.value || '';
    const hoy = `${valor('year')}-${valor('month')}-${valor('day')}`;
    return fecha > hoy;
  }

  marcarRealizado(cuidado: any) {
    if (this.esCuidadoFuturo(cuidado)) return;
    // Una ocurrencia recurrente completada avanza a la siguiente fecha desde PHP.
    this.query.query('cuidados', 'MARCAR_REALIZADO', {mc_id: cuidado.mc_id, realizado: cuidado.mc_realizado !== 'X'}).subscribe({
      next: (resultado: any) => {
        if (resultado?.resultado === 'ERROR') { Swal.fire('Error', resultado.mensaje || 'No se pudo actualizar.', 'error'); return; }
        this.getCuidados(); this.getNextcuidado();
      },
      error: () => Swal.fire('Error', 'No se pudo actualizar el cuidado.', 'error')
    });
  }

  nuevoCuidado() {
    this.nuevocuidado = { mc_id: 0, mc_us_id: this.perfil.ID, mc_ma_id: this.mascotaSeleccionada?.ma_id || (this.mascotas.length === 1 ? this.mascotas[0].ma_id : 0), mc_tipo: '', mc_fecha: '', mc_hora: '', mc_notas: '', mc_realizado: '', mc_caducado: '', mc_periodicidad: 'ninguna', mc_intervalo: 1, va_nombre: '', ma_nombre: '' };
  }

  editarCuidado(cuidado: any) {
    this.nuevocuidado = { ...cuidado };
  }

  validaFormulario() {
    return !(this.nuevocuidado.mc_ma_id && this.nuevocuidado.mc_tipo && this.nuevocuidado.mc_fecha && this.nuevocuidado.mc_hora) || (this.nuevocuidado.mc_periodicidad === 'personalizada' && !(Number(this.nuevocuidado.mc_intervalo) >= 1 && Number(this.nuevocuidado.mc_intervalo) <= 3650));
  }

  eliminarCuidado(cuidado: any) {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres borrar este cuidado?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.query.query('cuidados', 'BORRAR', cuidado).subscribe((resultado:any) => {
          this.getCuidados();
          this.getNextcuidado();
        });
      } else {
      }
    });
  }

  getNextcuidado() {
    if (this.misdatos.ID != this.perfil.ID) return;

    this.query.query('cuidados', 'GET', { limit: 1, intervalo: 3650, realizado: '' }).subscribe((resultado:any) => {
      this.saludService.setCuidado(resultado.registros[0] || {});
    });
  }

}
